import React, { Component } from 'react';
import {Doughnut} from "react-chartjs-2";
import AnalyticsDoughnutUtils, {AnalyticsDoughnutPalette} from "./AnalyticsDoughnutUtils";

interface SimpleDoughnutProps {
    title: string;
    
    aValue: number;
    aLabel: string;
    aColour: AnalyticsDoughnutPalette;
    
    bValue: number;
    bLabel: string;
    bColour: AnalyticsDoughnutPalette;
}

interface SimpleDoughnutState {
}

export default class SimpleDoughnut extends Component<SimpleDoughnutProps, SimpleDoughnutState> {
    static displayName = SimpleDoughnut.name;

    
    constructor(props: SimpleDoughnutProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {

    }


    componentDidUpdate(prevProps: Readonly<SimpleDoughnutProps>, prevState: Readonly<SimpleDoughnutState>, snapshot?: any): void {

    }


    render(): JSX.Element {
        
        const chartOptions = AnalyticsDoughnutUtils.chartOptions(this.props.title);

        const doughnutChartData = {
            labels: [
                this.props.aLabel,
                this.props.bLabel
            ],
            datasets: [{
                data: [this.props.aValue,this.props.bValue],
                backgroundColor: [
                    this.props.aColour,
                    this.props.bColour
                ]
            }]
        };

        return (
            <div className="doughnut-holder doughnut-holder--medium doughnut-holder--centered">
                <Doughnut data={doughnutChartData} options={chartOptions} height={2} width={4}/>
            </div>
        );
    }
}